import {
  CONS_CLIENTS_LOADING_START,
  CONS_CLIENTS_LOADING_SUCCESS,
  CONS_CLIENTS_LOADING_FAILED,
  CHANGE_CONS_CLIENTS_PAGE,
  CHANGE_CONS_CLIENTS_LIMIT,
  //Сортировка
  CHANGE_CONS_CLIENTS_SORTING,
} from '../actions/consultantClientsList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  clients: [],
  total: 0,
  limit: 15,
  activePage: 1,
  search: '',
  activeSearch: '',
  sorting: {
    sort: 'created_at',
    order: true,
  }
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case CONS_CLIENTS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        clients: [],
        total: 0,
      };
    case CONS_CLIENTS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        clients: action.payload.clients.customers,
        total: parseInt(action.payload.clients.total, 10),
      };
    case CONS_CLIENTS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    case CHANGE_CONS_CLIENTS_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,   
      };
    case CHANGE_CONS_CLIENTS_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    //Сортировка
    case CHANGE_CONS_CLIENTS_SORTING:
      return {
        ...state,
        sorting: action.payload, 
        activePage: INITIAL_STATE.activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}